import { useMutation, useQueryClient } from '@tanstack/react-query';

import { resendLoginLink } from '../api/users';
import { Queries } from '../types/queries';

/** Sends a new login link to an existing user and refreshes the user directory. */
const useResendLoginLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resendLoginLink,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [Queries.UserList] }),
  });
};

export default useResendLoginLink;
